export default __webpack_public_path__ + "static/media/121.7a60a3da.png";